import {Button, Card, Form, Icon, Input, Select, Spin, Tooltip} from 'antd';
import React from "react";
import {getFormFieldByType, sanitizeFieldName} from "../../util/methods";
import DocumentList from "../../components/DocumentList";
import SubList from "../../components/SubList";
import FieldSearchForm from "../../components/FieldSearchForm";
import SuperMasterModal from "../../components/SuperMasterModal";
import InlineCreateMasterModal from "../../components/InlineCreateMasterModal";

class Create extends React.Component {

  state = {
    showReadings: false,
    documentData: [],
    createdEquipmentSubTypes: [],
    createdAssetModels: [],
  };

  componentDidMount() {
    const {match, fetch} = this.props;
    if (match.params && match.params.id) {
      fetch && fetch(match.params.id);
    }
  }

  componentWillReceiveProps(nextProps, nextContext) {
    if (nextProps && nextProps.data && (JSON.stringify(nextProps.data.readings) !== JSON.stringify(this.props.data.readings))) {
      if (nextProps.data.readings && nextProps.data.readings.length) {
        this.setState({showReadings: true});
      }
    }
  }

  getDocumentData = (data) => {
    this.setState({documentData: data});
  };

  findAssetModel = (values) => {
    this.props.findAssetModelBySubType(values);
  }

  handleSubmit = (e) => {
    const {match} = this.props;
    e.preventDefault();
    e.stopPropagation();

    this.props.form.validateFields(async (err, values) => {
      if (err) {
        return console.log(err);
      }
      const {documentData} = this.state;
      const data = Object.assign({}, values);
      const equipmentSubTypeOptions = this.getEquipmentSubTypeOptions();
      const assetModelOptions = this.getAssetModelOptions();
      const selectedAssetModel = (assetModelOptions || []).find(item => `${item && item._id}` === `${data.assetModel}`);
      if (selectedAssetModel) {
        data.assetModel = this.props.title === 'CREATE' ? selectedAssetModel : selectedAssetModel._id;
        const selectedSubType = selectedAssetModel.assetSubType;
        const selectedSubTypeId = this.getIdValue(selectedSubType);
        data.equipmentSubType = this.props.title === 'CREATE'
          ? (selectedSubType && selectedSubType._id ? selectedSubType : data.equipmentSubType)
          : selectedSubTypeId;
      }
      if (this.props.title === 'CREATE') {
        const selectedSubTypeId = this.getIdValue(data.equipmentSubType);
        if (selectedSubTypeId) {
          const selectedSubTypeOption = (equipmentSubTypeOptions || []).find(
            (item) => `${item && item._id}` === selectedSubTypeId
          );
          if (selectedSubTypeOption) {
            data.equipmentSubType = selectedSubTypeOption;
          }
        }
      }
      if (documentData.length === 0) {
        data.documents = this.props && this.props.data && this.props.data.documents;
      } else {
        data.documents = documentData;
      }

      if (!this.props.dependent && this.props.fromModal) {
        this.props.saveOwner(data.owner);
      }

      if (match.params && match.params.id) {
        this.props.onSubmit(data, match.params.id);
      } else {
        this.props.onSubmit(data);
      }
    });
  };

  getAssetCode = (e) => {
    this.props.fetchAssetCodeByModelId(e);
  };

  handleLinkedAssetSelect = (e) => {
    this.setState({showReadings: true});
  };

  handleParentSelected = (values, index) => {
    this.props.getLinkedAssetData(true, index);
  }

  handleSubAssetChange = (e) => {
    const {form} = this.props;
    form.setFieldsValue({
      assetModel: '',
    })
  }

  mergeUniqueOptions = (baseOptions = [], createdOptions = []) => {
    const merged = [...(baseOptions || [])];
    (createdOptions || []).forEach((created) => {
      if (!created || !created._id) {
        return;
      }
      const exists = merged.find((option) => `${option && option._id}` === `${created._id}`);
      if (!exists) {
        merged.push(created);
      }
    });
    return merged;
  }

  getEquipmentSubTypeOptions = () => {
    const { filters } = this.props;
    const baseOptions = filters && filters.equipmentSubType && filters.equipmentSubType.data && filters.equipmentSubType.data.data || [];
    const createdFromModels = (this.state.createdAssetModels || [])
      .map((model) => model && model.assetSubType)
      .filter((subType) => subType && subType._id && subType.name);
    const withCreatedSubTypes = this.mergeUniqueOptions(baseOptions, this.state.createdEquipmentSubTypes);
    return this.mergeUniqueOptions(withCreatedSubTypes, createdFromModels);
  }

  getAssetModelOptions = () => {
    const baseOptions = this.props.assetModel || [];
    return this.mergeUniqueOptions(baseOptions, this.state.createdAssetModels);
  }

  getIdValue = (value) => {
    if (!value) return '';
    if (typeof value === 'string' || typeof value === 'number') return `${value}`;
    if (typeof value === 'object') return `${value._id || value.id || ''}`;
    return '';
  }

  getSelectedAssetModel = () => {
    const selectedAssetModelId = this.getIdValue(this.props.form.getFieldValue('assetModel'));
    const selectedFromOptions = (this.getAssetModelOptions() || []).find(
      (item) => `${item && item._id}` === selectedAssetModelId
    );
    if (selectedFromOptions) {
      return selectedFromOptions;
    }
    return this.props.data && this.props.data.assetModel ? this.props.data.assetModel : null;
  }

  renderConditionalDeviceIdField = (item, filterConfig, getFieldDecorator, data, title, selectedAssetModel) => {
    const visibilityByField = {
      tagDeviceId: !!(selectedAssetModel && selectedAssetModel.isTagDevice),
      fuelSensorId: !!(selectedAssetModel && selectedAssetModel.isFuelSensorDevice),
      rfidTagId: !!(selectedAssetModel && selectedAssetModel.isRfidTag),
      bleTagId: !!(selectedAssetModel && selectedAssetModel.isBleTag),
    };
    if (!visibilityByField[item]) {
      return null;
    }

    const label = sanitizeFieldName(
      filterConfig && filterConfig.options && filterConfig.options.label
        ? filterConfig.options.label
        : item
    );
    const description = filterConfig && filterConfig.options && filterConfig.options.description;
    const value = data && Object.prototype.hasOwnProperty.call(data, item) ? data[item] : '';

    return (
      <Form.Item key={item}
                 label={<span>
                   {label}&nbsp;
                   {description ? (
                     <Tooltip title={description}>
                       <Icon type="question-circle-o" />
                     </Tooltip>
                   ) : null}
                 </span>}>
        {getFieldDecorator(item, {
          rules: [{ required: true, message: `${label} is required!` }],
          initialValue: value,
        })(<Input
          placeholder={`Please Enter ${sanitizeFieldName(filterConfig.field || item)}`}
          disabled={title === 'EDIT' && filterConfig && filterConfig.options && filterConfig.options.disabledOnEdit}
          autoComplete={'off'} />)}
      </Form.Item>
    );
  }

  handleInlineEquipmentSubTypeCreated = (createdSubType) => {
    if (!createdSubType || !createdSubType._id) {
      return;
    }
    this.setState((prevState) => {
      const exists = (prevState.createdEquipmentSubTypes || []).find((item) => `${item._id}` === `${createdSubType._id}`);
      if (exists) {
        return null;
      }
      return {
        createdEquipmentSubTypes: [...(prevState.createdEquipmentSubTypes || []), createdSubType],
      };
    });
    this.props.form.setFieldsValue({
      equipmentSubType: createdSubType._id,
      assetModel: undefined,
    });
    this.findAssetModel(createdSubType._id);
  }

  handleInlineAssetModelCreated = (createdAssetModel) => {
    if (!createdAssetModel || !createdAssetModel._id) {
      return;
    }
    this.setState((prevState) => {
      const exists = (prevState.createdAssetModels || []).find((item) => `${item._id}` === `${createdAssetModel._id}`);
      if (exists) {
        return null;
      }
      return {
        createdAssetModels: [...(prevState.createdAssetModels || []), createdAssetModel],
      };
    });
    const createdSubType = createdAssetModel && createdAssetModel.assetSubType;
    if (createdSubType && createdSubType._id && createdSubType.name) {
      this.setState((prevState) => {
        const subtypeExists = (prevState.createdEquipmentSubTypes || []).find(
          (item) => `${item._id}` === `${createdSubType._id}`
        );
        if (subtypeExists) {
          return null;
        }
        return {
          createdEquipmentSubTypes: [...(prevState.createdEquipmentSubTypes || []), createdSubType],
        };
      });
    }
    const currentSelectedSubTypeId = this.getIdValue(this.props.form.getFieldValue('equipmentSubType'));
    const createdSubTypeId = this.getIdValue(createdAssetModel.assetSubType) || currentSelectedSubTypeId;
    if (createdSubTypeId) {
      this.props.form.setFieldsValue({
        equipmentSubType: createdSubTypeId,
      });
      this.findAssetModel(createdSubTypeId);
    }
    this.props.form.setFieldsValue({
      assetModel: createdAssetModel._id,
    });
  }

  render() {
    const {getFieldDecorator, setFieldsValue} = this.props.form;
    const {data, loading, filters, subDocumentFilters, title, resource, form} = this.props;
    let subMaster = (this.props && this.props.subMaster) || false;
    const useAssetModelInlineCreate = !!this.props.useAssetModelInlineCreate;
    const equipmentSubTypeOptions = this.getEquipmentSubTypeOptions();
    const assetModelOptions = this.getAssetModelOptions();
    const selectedAssetModel = this.getSelectedAssetModel();
    const {showReadings} = this.state;
    // console.log(data)
    return (
      <Spin spinning={loading}>
        <Card className={`gx-card-metrics`} title={`${title} ${sanitizeFieldName(resource || '')}`}>
          <Form onSubmit={this.handleSubmit} layout="vertical">

            <Form.Item key={'equipmentSubType'} label={'Equipment Sub Type'}>
              {getFieldDecorator('equipmentSubType', {
                rules: [{required: true, message: `EquipmentSubType is required!`}],
                initialValue: this.getIdValue(data && data.equipmentSubType),
              })(<Select
                showSearch
                style={{width: '80%'}}
                placeholder="Please select"
                onSelect={this.findAssetModel}
                onChange={this.handleSubAssetChange}
                filterOption={(input, option) =>
                  (option.props.children + "").toLowerCase().indexOf((input + "").toLowerCase()) >= 0
                }
                disabled={(filters['equipmentSubType'] && filters['equipmentSubType'].options.disabledOnEdit) || false}
              >
                {(equipmentSubTypeOptions || []).map(item =>
                  <Select.Option key={item._id} value={item._id}>{item.name}</Select.Option>)}
              </Select>)}
              {
                useAssetModelInlineCreate ? <InlineCreateMasterModal
                  item={'EquipmentSubType'}
                  onCreated={this.handleInlineEquipmentSubTypeCreated}
                  triggerStyle={{
                    margin: '0',
                    marginTop: '0',
                    marginLeft: '10px',
                    width: 'calc(100% - 10px)'
                  }}
                /> :
                filters['equipmentSubType'] && filters['equipmentSubType'].options.superMaster ?
                  <SuperMasterModal subMaster={this.props.subMaster || false} resource={resource}
                                    item={filters['equipmentSubType'].options.ref}
                                    title={'CREATE'}/> : ''
              }
            </Form.Item>

            <Form.Item key={'assetModel'} label={'Asset Model'}>
              {getFieldDecorator('assetModel', {
                rules: [{required: true, message: `Asset Model is required!`}],
                initialValue: this.getIdValue(data && data.assetModel),
              })(<Select
                showSearch
                style={{width: '80%'}}
                placeholder="Please select"
                filterOption={(input, option) =>
                  (option.props.children + "").toLowerCase().indexOf((input + "").toLowerCase()) >= 0
                }
                disabled={(title === 'EDIT' && filters['assetModel'] && filters['assetModel'].options.disabledOnEdit) || false}
              >
                {(assetModelOptions || []).map(item =>
                  <Select.Option key={item._id} value={item._id}>{item.name}</Select.Option>)}
              </Select>)}
              {
                useAssetModelInlineCreate ? <InlineCreateMasterModal
                  item={'AssetModel'}
                  initialAssetSubTypeId={this.props.form.getFieldValue('equipmentSubType')}
                  onCreated={this.handleInlineAssetModelCreated}
                  triggerStyle={{
                    margin: '0',
                    marginTop: '0',
                    marginLeft: '10px',
                    width: 'calc(100% - 10px)'
                  }}
                /> :
                filters['assetModel'] && filters['assetModel'].options.superMaster ?
                  <SuperMasterModal subMaster={this.props.subMaster || false} resource={resource}
                                    subTypeId={this.props.form.getFieldValue('equipmentSubType')}
                                    findAssetModelBySubType={this.props.findAssetModelBySubType}
                                    onCreated={this.handleInlineAssetModelCreated}
                                    item={filters['assetModel'].options.ref} title={'CREATE'}/> : ''
              }
            </Form.Item>

            {
              (title === 'EDIT') && <Form.Item key={'assetCode'} label={'Asset Code'}>
                {getFieldDecorator('assetCode', {
                  rules: [{required: false, message: `assetCode is required!`}],
                  initialValue: this.props && this.props.assetCode ? this.props.assetCode : ((data && data.assetCode) || ''),
                })(<Input disabled/>)
                }
              </Form.Item>
            }
            {
              (title === 'EDIT') && <Form.Item key={'ownerCode'} label={'Owner Code'}>
                {getFieldDecorator('ownerCode', {
                  rules: [{required: false, message: `ownerCode is required!`}],
                  initialValue: this.props && this.props.ownerCode ? this.props.ownerCode : ((data && data.ownerCode) || ''),
                })(<Input/>)
                }
              </Form.Item>
            }

            {Object.keys(filters).map((item) => {
              if (filters[item].field === 'assetType' || filters[item].field === 'standardFuelConsumptionRateHistory') {
                return;
              } else if (filters[item].type === 'Array' && filters[item].options.ref === 'Document') {
                return <DocumentList history={this.props.history} match={this.props.match} key={item}
                                     item={filters[item]} form={form} data={data[item]}
                                     subDocumentFilters={subDocumentFilters}
                                     getDocumentData={this.getDocumentData} disableAdd/>
              } else {
                if (['tagDeviceId', 'fuelSensorId', 'rfidTagId', 'bleTagId'].includes(item)) {
                  return this.renderConditionalDeviceIdField(
                    item,
                    filters[item],
                    getFieldDecorator,
                    data,
                    title,
                    selectedAssetModel
                  );
                } else if (filters[item].options.ref !== 'EquipmentSubType' && filters[item].options.ref !== 'AssetModel') {
                  if (filters[item].field !== 'assetCode' && filters[item].field !== 'ownerCode' && filters[item].field !== 'parent' && filters[item].field !== 'readings') {
                    return getFormFieldByType(filters, item, getFieldDecorator, data, {
                      title: title,
                      resource,
                      subMaster: subMaster,
                      dependent: this.props.dependent,
                      owner: this.props.owner,
                      onEditOptional: filters[item].field === 'location' ? 'yes' : ''
                    });
                  }
                }
                if (filters[item].field === 'parent' && !filters[item].options.hidden && !this.props.dependent) {
                  return <FieldSearchForm
                    title={title}
                    key={'parent'}
                    name={'parent'}
                    label={'Linked Asset'}
                    message={''}
                    required={false}
                    disabled={title === 'EDIT'}
                    field={filters.parent.options.main}
                    model={filters.parent.options.ref}
                    initialValue={data && data.parent}
                    getFieldDecorator={getFieldDecorator}
                    setFieldsValue={setFieldsValue}
                    onSelect={(values, ind) => {
                      this.handleParentSelected(values, this.props.index)
                    }}
                  />
                }

                if (filters[item].field === 'readings' && showReadings) {
                  return <SubList key={item} item={filters && filters[item]} form={form}
                                  data={data && data[item]}
                                  title={title} resource={resource}/>
                }
              }
            })}

            <Form.Item>
              <Button type="primary" className="gx-mb-0" htmlType="submit" loading={loading}>
                {this.props.title === 'EDIT' ? 'UPDATE' : 'CREATE'}
              </Button>
            </Form.Item>
          </Form>
        </Card>
      </Spin>
    );
  }
}

const CreateForm = Form.create({
  name: 'global_state',
  onFieldsChange(props, changedFields) {
    props.onChange(changedFields);
  },
})(Create);

export default CreateForm;
